import { stringify } from 'qs';
import request from '@/services/request';
import { url } from '../service-utils';

/**
 * 标签列表
 * 页面：获取分组树
 * 前端：林晓清
 * 后端：蒋东明
 * @params {Object} params: {appCode , pageSize , page}
 */
export async function getAllGroupList(params) {
  return request(`${url.url}/label/group/list/all?${stringify(params)}`);
}

export async function getGroupList(params) {
  return request(`${url.url}/label/group/list/page?${stringify(params)}`);
}


/**
 * 标签列表
 * 页面：标签设置页
 * 前端：洪芳
 * 后端： 陈陈
 * @params {Object} params: {appCode , pageSize , page}
 */
export async function getLabelList(params) {
  return request(`${url.url}/v3/label/list?${stringify(params)}`);
}

/**
 * 标签撤下/上线
 * 页面：标签设置页
 * 前端：洪芳
 * 后端： 陈陈
 * @params {Object} params: {appCode , id:标签id , upAndDown:0,上线。1撤下}
 */
export async function upAndDownLabel(params) {
  return request(`${url.url}/v3/label/upAndDownLabel?${stringify(params)}`);
}

/**
 * 删除标签
 * 页面：标签设置页
 * 前端：洪芳
 * 后端： 陈陈
 * @params {Object} params: {appCode , id:标签id }
 */

export async function labelDelete(params) {
  return request(`${url.url}/v3/label/delete?${stringify(params)}`);
}

/**
 * 新建/编辑标签
 * 页面：标签设置页
 * 前端：洪芳
 * 后端： 范腾
 * @params {Object} params: {appCode , id:0：添加，>0修改 ,label:标签名称}
 */
export function addAndModifyLabel(params) {
  return request(`${url.url}/v3/label/addAndModifyLabel`, {
    method: 'post',
    data: params,
  });
}

/**
 * 新建/编辑分组
 * 页面：新建/编辑分组
 * 前端：林晓清
 * 后端：蒋东明
 * @params {Object} params: {appCode , id:0：添加，>0修改 ,label:标签名称}
 */
export function addGroup(params) {
  return request(`${url.url}/label/group/add`, {
    method: 'post',
    data: params,
  });
}

export function modifyGroup(params) {
  return request(`${url.url}/label/group/update`, {
    method: 'post',
    data: params,
  });

}


export async function groupDelete(params) {
  return request(`${url.url}/label/group/delete?${stringify(params)}`);
}

export async function groupSwitch(params) {
  return request(`${url.url}/label/group/switch?${stringify(params)}`);
}

export async function groupMove(params) {
  return request(`${url.url}/label/group/move?${stringify(params)}`);
}

export async function labelMove(params) {
  return request(`${url.url}/v3/label/move?${stringify(params)}`);
}















